import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle, ShieldCheck } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative w-full bg-[#FFF9F3] overflow-hidden pt-12 pb-20 px-4 md:pt-20 md:pb-24" data-id="element-90">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-91">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-6 text-center md:text-left order-2 md:order-1" data-id="element-92">
          <div className="inline-flex items-center justify-center md:justify-start space-x-2 text-[#E8734A] font-semibold tracking-wide uppercase text-sm" data-id="element-93">
            <span className="bg-[#E8734A]/10 px-3 py-1 rounded-full" data-id="element-94">
              Para padres con niños de 18-24 meses
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#1B2A4A] leading-tight" data-id="element-95">
            Si te preocupa… <br data-id="element-96" />
            <span className="text-[#2ABFBF]" data-id="element-97">no esperes sin un plan.</span>
          </h1>

          <p className="text-xl md:text-2xl text-[#2D3436] font-medium leading-relaxed" data-id="element-98">
            Menos Google. Más claridad en 30 minutos.
          </p>

          <div className="pt-4 flex flex-col items-center md:items-start space-y-4" data-id="element-99">
            <Button size="lg" className="w-full md:w-auto text-lg shadow-xl" onClick={() => {
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-100">
              Quiero mi Ruta Clara — $19
            </Button>

            <div className="flex items-center space-x-2 text-sm text-[#2D3436]/70" data-id="element-101">
              <ShieldCheck className="w-4 h-4 text-[#2ABFBF]" data-id="element-102" />
              <span data-id="element-103">Acceso inmediato · PDF + imprimibles · Guía educativa</span>
            </div>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative order-1 md:order-2 flex justify-center" data-id="element-104">
          <div className="relative w-full max-w-[400px]" data-id="element-105">
            {/* Decorative blob behind */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#2ABFBF]/10 rounded-full blur-3xl -z-10" data-id="element-106" />

            <img src="https://cdn.magicpatterns.com/uploads/irKaqurs8LtkrDgY762GGi/imagen_perfecta_para_mi_ebooks.png" alt="La Ruta Clara Book Cover" className="w-full h-auto drop-shadow-2xl transform rotate-[-2deg] hover:rotate-0 transition-transform duration-500" data-id="element-107" />
          </div>
        </motion.div>
      </div>
    </section>;
};